import {MantineProvider, v8CssVariablesResolver} from "@mantine/core";
import React from 'react'
import ReactDOM from 'react-dom/client'
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import App from './App.jsx'
import '@mantine/core/styles.layer.css';
import '@mantine/notifications/styles.layer.css';
import '@mantine/dates/styles.layer.css';
import '@mantine/charts/styles.css';
import 'mantine-datatable/styles.layer.css';

import './style.css';
import './fools.css';
import {
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType,
} from "react-router";
import {MessageProvider} from "./context/MessageContext.tsx";
import {forgeTheme} from "./theme/mantineTheme";

const client = new QueryClient();

import * as Sentry from "@sentry/react";
import AppData from "../version.json";

Sentry.init({
    dsn: "https://c5ee4d27c34c18da5fc1ee216b585909@o4508699540389888.ingest.de.sentry.io/4508882025054288",
    integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect: React.useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
        }),
    ],
    beforeSend(event, hint) {
        const error = hint.originalException;
        if (error && error.isAxiosError && (!error.response || error.response.status === 401)) {
            return null;
        }
        return event;
    },
    environment: import.meta.env.VITE_FORGE_ENV,
    enabled: import.meta.env.VITE_FORGE_ENV !== 'dev',
    release: "swc-forge@"+AppData.version,
    // Tracing
    tracesSampleRate: 1, //  Capture all transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/swc-forge.com/, /^https:\/\/api.swc-forge.com/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

ReactDOM.createRoot(document.getElementById('root')).render(
    <MantineProvider
        theme={forgeTheme}
        defaultColorScheme="dark"
        cssVariablesResolver={v8CssVariablesResolver}
    >
        <MessageProvider>
            <QueryClientProvider client={client}>
                <App/>
            </QueryClientProvider>
        </MessageProvider>
    </MantineProvider>
)
